export const ORDER_STATUSES = [
  'CREATED',
  'PENDING_CONFIRMATION',
  'REJECTED',
  'CONFIRMED',
  'PREPARING',
  'READY',
  'DELIVERING',
  'SERVED',
  'COMPLETED',
  'CANCELLED',
  'REFUNDED',
] as const

export type OrderStatus = typeof ORDER_STATUSES[number]

export const ORDER_TYPES = ['DELIVERY', 'PICKUP', 'DINE_IN'] as const
export type OrderType = typeof ORDER_TYPES[number]

const ORDER_ACTIONS: Record<string, OrderStatus[]> = {
  PENDING_CONFIRMATION: ['CONFIRMED', 'REJECTED', 'CANCELLED'],
  CONFIRMED: ['PREPARING', 'CANCELLED'],
  PREPARING: ['READY', 'CANCELLED'],
  READY: ['COMPLETED', 'CANCELLED'],
  COMPLETED: [],
  REJECTED: [],
  CANCELLED: [],
  CREATED: [],
  DELIVERING: [],
  SERVED: [],
  REFUNDED: [],
}

export function availableOrderActions(status: string | undefined): OrderStatus[] {
  if (!status) return []
  return ORDER_ACTIONS[status] ?? []
}

export const ORDER_CHANGE_REASON = 'merchant_status_change'